import { Box, Link as MuiLink } from '@mui/material'

import logoDark from '~/assets/images/corp/logo-dark.svg'
import MarketingLink from '~/components/marketingLink'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { getImgUrlByType, isLibbyDomain } from '~/features/partners/utils'
import { EClientPath, EMarketingClientPath } from '~/models/api'
import rem from '~/utils/ui'

function Logo() {
  const isPartner = !isLibbyDomain()
  const { partner } = usePartnerCentralized()
  const logoSrc = isPartner
    ? getImgUrlByType(ESiteImagesTypes.logoDark, partner)
    : logoDark
  return (
    logoSrc && (
      <MuiLink
        component={MarketingLink}
        to={isPartner ? EClientPath.login : EMarketingClientPath.home}
        sx={{ textDecoration: 'none', mr: { xxxs: 1, xs: 2 } }}
      >
        <Box
          component="img"
          alt="logo"
          src={logoSrc}
          sx={{
            width: {
              xxxs: rem(80),
              sm: rem(180),
            },
          }}
        />
      </MuiLink>
    )
  )
}

export default Logo
